import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { initialState } from "../types";

const selectDomain = (state?: RootState) =>
  state?.questionnaireResultState || initialState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);
export const selectList = createSelector([selectDomain], (state) => state.list);
export const selectQuery = createSelector(
  [selectDomain],
  (state) => state.query
);
export const selectEdit = createSelector([selectDomain], (state) => state.form);
export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);
export const selectQuestionnaireResultId = createSelector(
  [selectDomain],
  (state) => state.questionnaireResultId
);
export const selectForm = createSelector([selectDomain], (state) => state.form);
export const selectQuestionList = createSelector(
  [selectDomain],
  (state) => state.questionList
);
